export default [
    {
        "id": "newsletter-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./newsletters/newsletter-1/html').default,
        "scss": require('./newsletters/newsletter-1/scss').default,
        "scssTablet": require('./newsletters/newsletter-1/scssTablet').default,
        "scssMobile": require('./newsletters/newsletter-1/scssMobile').default,
        "css": require('./newsletters/newsletter-1/css').default,
        "cssTablet": require('./newsletters/newsletter-1/cssTablet').default,
        "cssMobile": require('./newsletters/newsletter-1/cssMobile').default,
        "js": require('./newsletters/newsletter-1/js').default,
        "minJs": require('./newsletters/newsletter-1/minJs').default,
        "svgContent": require('./newsletters/newsletter-1/svgContent').default,
        "svgViewBox": "0 0 1440 288",
        "svgContentMobile": require('./newsletters/newsletter-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 513"
    },

    {
        "id": "newsletterPopup-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./newsletters/newsletterPopup-1/html').default,
        "scss": require('./newsletters/newsletterPopup-1/scss').default,
        "scssMobile": require('./newsletters/newsletterPopup-1/scssMobile').default,
        "css": require('./newsletters/newsletterPopup-1/css').default,
        "cssMobile": require('./newsletters/newsletterPopup-1/cssMobile').default,
        "js": require('./newsletters/newsletterPopup-1/js').default,
        "minJs": require('./newsletters/newsletterPopup-1/minJs').default,
        "svgContent": require('./newsletters/newsletterPopup-1/svgContent').default,
        "svgViewBox": "0 0 652 320",
        "fixedView": true,
        "showArrow": false,
        "isPopup": true,
    }
]